import { render, staticRenderFns } from "./OrderFilesTable.vue?vue&type=template&id=5cf47bd5&scoped=true&"
import script from "./OrderFilesTable.vue?vue&type=script&lang=ts&"
export * from "./OrderFilesTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderFilesTable.vue?vue&type=style&index=0&id=5cf47bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf47bd5",
  null
  
)

/* custom blocks */
import block0 from "./OrderFilesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports